export const storeTypes = {
	SET_PROBLEMS: "SET_PROBLEMS",
};
